import React from "react";
import T from "prop-types";
import { translateProps, manageFields } from "MODULES/shared/decorators";
import {
  Modal,
  Close,
  Header,
  Body,
  Footer
} from "MODULES/shared/components/Modal";
import { CANCELLATION_REASONS } from "MODULES/SalesOrders/constants";
import { CANCELLATION_REASON } from "MODULES/PurchaseOrders/constants";

export function Reason({
  onSubmit,
  visible,
  close,
  reason,
  sendCancellationEmail,
  updateReason,
  submitting,
  toggleSubmitting
}) {
  const submit = () => {
    toggleSubmitting();
    return onSubmit(reason, sendCancellationEmail).then(toggleSubmitting);
  };

  return (
    <Modal open={visible} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Cancel Part</h4>
      </Header>
      <Body>
        <div>
          <select
            className="form-control"
            name={CANCELLATION_REASON}
            value={reason}
            onChange={e => updateReason(e.target.value)}
          >
            {CANCELLATION_REASONS.map(r => (
              <option key={r.value} value={r.value}>
                {r.text}
              </option>
            ))}
          </select>
        </div>
      </Body>
      <Footer>
        <button type="button" className="btn btn-default" onClick={close}>
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          onClick={submit}
          disabled={submitting}
        >
          Save
        </button>
      </Footer>
    </Modal>
  );
}

Reason.propTypes = {
  sendCancellationEmail: T.bool.isRequired,
  onSubmit: T.func.isRequired,
  toggleSubmitting: T.func.isRequired,
  visible: T.bool.isRequired,
  close: T.func.isRequired,
  reason: T.string.isRequired,
  updateReason: T.func.isRequired,
  submitting: T.bool.isRequired
};

const withReason = manageFields({
  reason: CANCELLATION_REASONS[0].value,
  sendCancellationEmail: false,
  submitting: false
});

const withProps = translateProps(({ updateField, toggleField }) => ({
  toggleSubmitting: toggleField("submitting"),
  updateReason: updateField("reason"),
  updateEmail: updateField("sendCancellationEmail")
}));

export default withReason(withProps(Reason));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Reason.jsx